export const PUTCALL_RATIO_BEAR_THRESHOLD = 1.0;
export const PUTCALL_RATIO_BULL_THRESHOLD = 0.7;

export const GRAPH_PAGE_HOUR_CHART_ID = 2;
export const RESEARCH_PAGE_DAILY_CHART_ID = 3;
export const RESEARCH_PAGE_HOUR_CHART_ID = 4;
export const ORDER_PAGE_DAILY_CHART_ID = 5;
export const SECURITY_OPTIONS_TAB_CHART_ID = 7;
export const WATCH_TRENDLINE_CHART_ID = 8;
export const WATCH_SHORTLIST_CHART_ID = 9;

export const KEYCODE_R = 82;

export const exchanges = ['CME', 'COMEX', 'NYMEX', 'CBOT', 'NASDAQ', 'NYSE', 'SMART'];

export const GENERAL_NOTE = 'GENERAL';

export const PREFERRED_START_DATE_HOUR = 9;
export const PREFERRED_END_DATE_HOUR = 17;

export const ACCOUNT_CODE_PAPERTRADING = 'DUM849122';
export const ACCOUNT_CODE_LIVE = 'U20681438';
